import { LazyAction, LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';
import { ComponentClass } from 'react';

import { CategoryWellProps } from './components/CategoryWell';
import { CategoryProps } from './components/Category';
import { CategoryMenuProps } from './components/CategoryMenu';
import { CategoryIconProps } from './components/CategoryIcon';
import { CategoryColorPickerHostProps } from './components/CategoryColorPickerHost';
import CategoryType from 'owa-service/lib/contract/CategoryType';

export { ComponentClass };
export { default as categoryStore, getStore } from './store/store';
export { default as CategoryWell } from './components/CategoryWell';
export { default as Category } from './components/Category';
export {
    default as getCategoryColorsForCategory,
    getDefaultNewCategoryColor,
} from './utils/getCategoryColorsForCategory';
export {
    default as isCategoryNameValid,
    isCategoryNameEmptyOrWhitespace,
    isCategoryNameDuplicate,
} from './utils/isCategoryNameValid';
export { default as CategoryColor, CategoryColorValue } from './store/schema/CategoryColor';
export {
    default as updateMasterCategoryListService,
} from './services/updateMasterCategoryListService';
export { getCategoryMenuProps } from './utils/getCategoryMenuProps';
export { default as getCategorySuggestions } from './utils/getCategorySuggestions';
export { default as getMasterCategoryList } from './utils/getMasterCategoryList';
export { default as CategoryActionSource } from './utils/CategoryActionSource';
export {
    DEFAULT_CATEGORY_COLOR_CODE,
    DEFAULT_NEW_CATEGORY_COLOR_CODE,
} from './utils/categoriesConstants';

export { default as isCategoryInMasterList } from './utils/isCategoryInMasterList';
export { getCategoryIdFromName, getCategoryNameFromId } from './utils/categoryIdNameConverter';
export { default as CategoryIcon } from './components/CategoryIcon';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Categories" */ './lazyIndex'));

export let lazyAddMasterCategories = new LazyImport(lazyModule, m => m.addMasterCategories);
export let lazyRemoveMasterCategories = new LazyAction(lazyModule, m => m.removeMasterCategories);
export let lazyChangeMasterCategories = new LazyAction(lazyModule, m => m.changeMasterCategories);
export let lazyGetMasterCategoriesList = new LazyAction(lazyModule, m => m.getMasterCategoryList);
export let CategoryMenu = createLazyComponent(lazyModule, m => m.CategoryMenu);
export let CategoryColorPickerHost = createLazyComponent(
    lazyModule,
    m => m.CategoryColorPickerHost
);
export {
    CategoryColorPickerHostProps,
    CategoryIconProps,
    CategoryMenuProps,
    CategoryProps,
    CategoryType,
    CategoryWellProps,
};
